// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false";

export const MASTER_APIs = {
  manageTraining: async (args = {}) => {
    let apiUrl = "/ma/v1/PLV1RSVLT1WGPDT1";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/PLV1RSVLT1WGPDT1";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getTrainings: async (args = {}) => {
    let apiUrl = "/ma/v1/OT7FS81ZHT8IJ0LC";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/OT7FS81ZHT8IJ0LC";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageTrainingAssign: async (args = {}) => {
    let apiUrl = "/ma/v1/L2MRXPFNTQPRJXO1";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/L2MRXPFNTQPRJXO1";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getTrainingAssigns: async (args = {}) => {
    let apiUrl = "/ma/v1/Z91GLXZF6RONH5JB";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/Z91GLXZF6RONH5JB";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageTrainingActivity: async (args = {}) => {
    let apiUrl = "/ma/v1/USV66G5ZBLM4Q7AL";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/USV66G5ZBLM4Q7AL";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getTrainingActivities: async (args = {}) => {
    let apiUrl = "/ma/v1/UJZ3QSR2EEIK0RQP";
    if (local) {
      apiUrl = "http://192.168.179.238:8005/ma/v1/UJZ3QSR2EEIK0RQP";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageGptMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/838I3515U68755JD",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  getGptMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/107C5643D53898BI",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Vehicles
  manageVehicle: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/243G1336Q39721XF",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Vehicles details
  getVehicles: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/768X3479A21866MW",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing driver
  manageDriver: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/805A3556N28311BV",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get driver details
  getDrivers: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/497F1872Q59764PF",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Add vehicle driver details
  manageVehicleDriver: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/506O5863Y93386XC",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get vehicle driver details
  getVehicleDrivers: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/910A8352X90318CK",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update Branch
  manageBranchProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/972C2154T55252HE",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get customer Branches
  getBranchProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/549I9528I50289QW",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageFareChart: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/463V6381L97251VK",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getFareChart: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/395M2086H67832OU",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageHolidays: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/546H9074T95520BK",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getHolidays: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/885O7965S48296AZ",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageLeaveTypes: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/607D5599N60637VW",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getLeaveTypes: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/859Q2704F49253VF",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageMktgTeam: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/676V6275F35069GK",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getMktgTeam: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/121Z9029X80381JW",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageGptBase: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/838I3515U68755JD",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getGptBase: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/107C5643D53898BI",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageScheme: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/849R6113S73487MU",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getScheme: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/544K1349L83793JC",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageTarget: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/116Y6852Y24601QB",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getTarget: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/580X8943L66542QT",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageOrgProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/8Z4QAVD6OUUG9XKD",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getOrgProfiles: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/GBAVZ6X1B4NZGXXE",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update
  manageLeaveApplication: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/0GZXN17DMQRC004P",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getLeaveApplications: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ma/v1/5OAGGGFOAYSCSHKP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
